import { render, staticRenderFns } from "./MForm.vue?vue&type=template&id=5b35b1b1&lang=pug&"
import script from "./MForm.vue?vue&type=script&lang=js&"
export * from "./MForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports